interface SectionTitleProps {
  children: React.ReactNode;
}

export function SectionTitle({ children }: SectionTitleProps) {
  return (
    <h4 className="text-sm font-medium text-gray-500 mb-3">
      {children}
    </h4>
  );
} 